import { render, staticRenderFns } from "./SelectCourseLeader.vue?vue&type=template&id=c2436b7c&lang=pug&"
import script from "./SelectCourseLeader.vue?vue&type=script&lang=js&"
export * from "./SelectCourseLeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports